var MobileBasket = function() {

    var hash_recompute = function(view, mid = MobileBasket.openmatch) {
        if (view) {
            MatchesTable.match_filter = view;
        }
        MobileBasket.openmatch = mid;
        var hash = MatchesTable.match_filter + (MobileBasket.openmatch ? ('_' + MobileBasket.openmatch) : '');
        if (window.history.state &&
            window.history.state.match &&
            !MobileBasket.openmatch) {
            window.history.back();
        } else if ((!window.history.state || !window.history.state.match) &&
                   MobileBasket.openmatch) {
            window.history.pushState(
                {view: MatchesTable.match_filter, match: MobileBasket.openmatch},
                null, '#' + hash);
        } else {
            window.history.replaceState(
                {view: MatchesTable.match_filter, match: MobileBasket.openmatch},
                null, '#' + hash);
        }
        return hash;
    };

    var parse_hash = function() {
        var parts = window.location.hash.substr(1).split('_');
        if (parts.length > 0 &&
            parts[0] in {'all': 1, 'fav': 1, 'live': 1, 'fin': 1, 'sched': 1}) {
            MatchesTable.match_filter = parts[0];
            MatchesTable.applyAllFilters();
        }
        if (parts.length > 1 && parseInt(parts[1]) > 0) {
            MobileBasket.openmatch = parts[1];
            MobileBasket.expandRow(MobileBasket.openmatch);
        }
    };

    return {
        matchesRefresh: function() {
            // refresh open match
            $('.ii__overlay__content.ii__matchopen').each(function(i, e) {
                var mid = $('.ii__overlay__content').data('mid');
                Ajax.getMobileMatchPage(true, mid, true, function(data) {
                    if (data.success != 'ok') {
                        return;
                    }
                    // replace only the contents of the first tab..
                    $(e).find('.ii__live_part').html(data.html);
                });
            });
            return Ajax.getBasketMatches(
                MobileBasket.date,
                MatchesTable.byleague,
                (res) => {
                    $('#results').html(res.html);
                    MatchesTable.filterMatches(MatchesTable.match_filter);
                    Generic.updateTimes();
                    MobileBasket.initExpandRow();
                    Generic.hideProgressLoader();
                }
            );
        },
        matchesRefreshLoop: function() {
            MobileBasket.matchesRefresh().finally(function() {
                setTimeout(MobileBasket.matchesRefreshLoop, 20 * 1000);
            });
        },
        init: function(byleague, date) {
            MatchesTable.init(byleague);
            MobileBasket.date = date;
            MobileBasket.openmatch = false;
            // filter matches buttons
            $('.ii__mf_btn').click(function() {
                var filter = $(this).data('filter');
                if (filter != undefined) {
                    MobileBasket.filterMatches(filter);
                }
            });
            MobileBasket.initExpandRow();
            parse_hash();
            $('.ii__om_btn').click(function() {
                var order = $(this).data('orderby');
                if (order != undefined) {
                    MobileBasket.order_matches(order);
                }
            });
            setTimeout(MobileBasket.matchesRefreshLoop, 20 * 1000);
            window.onpopstate = function(event) {
                MobileBasket.closeMatch();
            };
            $('.ii__overlay_close').click(function() {
                MobileBasket.closeMatch();
            });
        },
        closeMatch: function() {
            $('.page').removeClass('overlay-on');
            $('.ii__overlay__content').empty();
            $('.ii__overlay__content').removeClass('ii__matchopen');
            $('.ii__overlay__content').removeData('mid');
            $('.ii__sticky_footer').show();
            MobileGeneric.sticky_footer_visible = true;
            hash_recompute(false, false);
        },
        filterMatches: function(status) {
            hash_recompute(status);
            MatchesTable.filterMatches(status);
        },
        initExpandRow: function() {
            $('.ii__match_row').off().click(function() {
                var agones_id = $(this).attr('id').substr(2);
                MobileBasket.expandRow(agones_id);
            });
        },
        expandRow: function(id) {
            hash_recompute(false, id);
            $('.ii__overlay__content').html('<div style=\"width: 100%;height: 100%;text-align: center;display: table;font-size: 1.5em;color: #ddd;\"><span style=\"display:table-cell; vertical-align:middle;\" class=\"fa-2x\"><i class=\"fas fa-circle-notch fa-spin\"></i></span></div>');
            $('#overlay-title').html('');
            $('.page').addClass('overlay-on');
            $('.ii__overlay__content').data('mid', id);
            $('.ii__sticky_footer').hide();
            MobileGeneric.sticky_footer_visible = false;
            Ajax.getMobileMatchPage(true, id, true, function(data) {
                if (data.success != 'ok') {
                    return;
                }
                $('#overlay-title').html(data.title);
                $('.ii__overlay__content').html(data.html);
                $('.ii__overlay__content').addClass('ii__matchopen');
                Generic.updateTimes();
            });
        },
        order_matches: function(ord) {
            if (ord == MatchesTable.byleague) {
                return;
            }
            if (ord == 'bytime') {
                $('.ii__om_time').addClass('active blue');
                $('.ii__om_league').removeClass('active blue');
            } else {
                $('.ii__om_time').removeClass('active blue');
                $('.ii__om_league').addClass('active blue');
            }
            Generic.showProgressLoader();
            MatchesTable.store_match_ordering(ord);
            MobileBasket.matchesRefresh();
        },
    };
}();
